import {
  LOGIN_SUCCESS,
  LOGOUT,
  STORE_REDIRECT_URL,
  CLEAR_REDIRECT_URL,
} from "../action/actionTypes";

const initialState = {
  isAuthenticated: false,
  user: null,
  redirectUrl: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    case STORE_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.payload,
      };
    case CLEAR_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: null,
      };

    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        redirectUrl: null,
      };

    default:
      return state;
  }
};

export default authReducer;
